import { render } from "./TopBrowsingPagesToday.vue?vue&type=template&id=30f74719&ts=true"
import script from "./TopBrowsingPagesToday.vue?vue&type=script&lang=ts"
export * from "./TopBrowsingPagesToday.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__